/**
 * 余额支付不支持 2023.12.1
 *
 * 注释掉对应的密码输入，余额展示
 */
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { MyForm } from '~/components/ui/MyForm'
import { MyModal } from '~/components/ui/MyModal'
import {
  CopyrightSettlementInput,
  OrderInfo,
  preSettlement,
  preSettlementVariables,
  preSettlement_settlementModule_copyrightPreSettlement,
  preSettlement_settlementModule_copyrightPreSettlement_payTypeList,
  toPay,
  toPayVariables,
  toPay_orderModule_copyrightPay,
} from '~/graphqls/types'
import { ProductInfo } from '../product/ProductInfo'
import { InputNumber, Switch, Radio, message, Tooltip, Modal } from 'antd'
import styled from 'styled-components'
import {
  FenToYuan,
  graphQLErrorCode,
  graphQLErrorMessage,
  isAmount,
  YuanToFen,
} from '~/utils'
import { MyBtn } from '~/components/ui/MyBtn'
import { SkuType } from '~/graphqls/types'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { TradePwdModal } from '~/components/pages/product/TradePwdModal'
import { OrderSuccessModal } from './OrderSuccessModal'
import { PRE_SETTLEMENT, TO_PAY } from '~/graphqls/gqls'
import { useImperativeQuery } from '~/hooks/useImperativeQuery'
import _ from 'lodash'
import CryptoJS from 'crypto-js'
import { ScanPayModal } from './ScanPayModal'
import { useMutation } from '@apollo/client'
import { InfoCard, InfoCardItem } from '~/components/business/pay/InfoCard'
import { observer } from 'mobx-react'
import { useValidateAuth } from '~/hooks/useValidateAuth'
import { useStores } from '~/hooks/useStores'
import {
  MIN_PRICE,
  MAX_PRICE,
  SkuTypeName,
  MAX_PAY,
  SkuTypeAgreement,
  AiSkuTypeAgreement,
} from '~/configs'
import { MysteryBoxModal } from './MysteryBoxModal'
import Router from 'next/router'
import { InfoCircleOutlined } from '@ant-design/icons'
import { MyCheckbox } from '~/components/ui/MyCheckbox'
import { PresetColorTypes } from 'antd/lib/_util/colors'

const StyledBuyRule = styled.div`
  font-size: 12px;
  line-height: 20px;
  color: ${props => props.theme.dark4};
  margin-bottom: 24px;
`

const StyledOrderAction = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  margin-top: 24px;
  border-top: 1px solid ${props => props.theme.light1};
`

const StyledOrderActionPrice = styled.div``

const StyledOrderActionPriceItem = styled.div`
  font-size: 12px;
  line-height: 20px;
  color: ${props => props.theme.dark4};
  span {
    font-size: 16px;
    color: ${props => props.theme.errorColor};
  }
`

const { confirm } = Modal

export const OrderModal: React.FC<{
  orderInfo: OrderInfo
  isMysteryBox?: boolean
  hasAdapt?: boolean
  visible: boolean
  setVisible: React.Dispatch<React.SetStateAction<boolean>>
  isAi?: boolean
}> = observer(
  ({
    visible,
    setVisible,
    orderInfo,
    isMysteryBox = false,
    hasAdapt = true,
    isAi,
  }) => {
    const [modal, modalSlot] = Modal.useModal()
    const [form] = MyForm.useForm()
    const { validateTradePwd } = useValidateAuth()
    const { store } = useStores()
    const [currentOrderInfo, setCurrentOrderInfo] = useState(orderInfo)

    const [tradePwdVisible, setTradePwdVisible] = useState(false)
    const [scanPayVisiable, setScanPayVisiable] = useState(false)
    const [paySuccessVisiable, setPaySuccessVisible] = useState(false)

    const [loading, setLoading] = useState(false)
    const [mounted, setMounted] = useState(false)

    // 三方支付信息
    const [payInfo, setPayInfo] = useState<toPay_orderModule_copyrightPay>()
    // 预结算参数
    const [settlementVars, setSettlementVars] =
      useState<CopyrightSettlementInput>({
        artworkId: currentOrderInfo?.id,
        buyType: currentOrderInfo?.buyType,
        num: 1,
        price: 0, // 出售价格
        useBalance:
          Number(store.userinfo?.metaWalletBalance?.[0]?.availableBalance) > 0,
      })

    // 预结算数据
    const [preSettlementData, setPreSettlementData] = useState<
      preSettlement_settlementModule_copyrightPreSettlement | null | undefined
    >()

    const getPreSelltement = useImperativeQuery<
      preSettlement,
      preSettlementVariables
    >(PRE_SETTLEMENT)

    useEffect(() => {
      getPreSelltement({
        settlement: settlementVars,
      })
        .then(data => {
          const copyrightPreSettlement = data?.data?.settlementModule
            ?.copyrightPreSettlement as preSettlement_settlementModule_copyrightPreSettlement

          setPreSettlementData({
            __typename: 'CopyrightSettlement',
            balance: copyrightPreSettlement?.balance || 0,
            balancePoint: copyrightPreSettlement?.balancePoint || 0,
            payTypeList: copyrightPreSettlement?.payTypeList || [],
            preIncome: copyrightPreSettlement?.preIncome || 0,
            sellPrice: copyrightPreSettlement?.sellPrice || 0,
            maxSellPrice: copyrightPreSettlement?.maxSellPrice || 0,
            totalFee: copyrightPreSettlement?.totalFee || 0,
            totalPoint: copyrightPreSettlement?.totalPoint || 0,
          })

          !currentPayType &&
            setCurrentPayType(copyrightPreSettlement?.payTypeList?.[0])

          setCurrentOrderInfo(value => {
            return {
              ...value,
              price: copyrightPreSettlement?.totalFee || value.price,
            }
          })

          setMounted(true)
        })
        .catch(err => {
          message.destroy()
          message.error(graphQLErrorMessage(err) || '获取数据失败，请重试')
          setVisible(false)
        })
    }, [settlementVars])

    // 是否同意协议
    const [isAgree, setIsAgree] = useState(false)

    // 是否使用余额
    // const [isUseBalance, setIsUseBalance] = useState(
    //   Number(store.userinfo?.metaWalletBalance?.[0]?.availableBalance) > 0
    // )
    const [isUseBalance, setIsUseBalance] = useState(false)

    // 是否使用三方支付
    const [isUsePay, setIsUsePay] = useState(
      Number(store.userinfo?.metaWalletBalance?.[0]?.availableBalance) <
        currentOrderInfo.price
    )

    // 当前三方支付类型
    const [currentPayType, setCurrentPayType] = useState<
      | preSettlement_settlementModule_copyrightPreSettlement_payTypeList
      | null
      | undefined
    >(null)

    // 是否能使用余额
    // const isCanBalance = useMemo(() => {
    //   return preSettlementData?.balance > 0
    // }, [preSettlementData])

    // 是否能使用三方支付: 1)余额不足时 2）余额足够，但余额支付关闭时
    const isCanPay = useMemo(() => {
      return (
        preSettlementData?.balance < preSettlementData?.totalFee ||
        (preSettlementData?.balance >= preSettlementData?.totalFee &&
          !isUseBalance)
      )
    }, [preSettlementData, isUseBalance])

    //实际使用余额
    const realUseBalance = useMemo(() => {
      if (!isUseBalance) return 0

      if (preSettlementData?.balance >= preSettlementData?.totalFee) {
        return preSettlementData?.totalFee
      } else {
        return preSettlementData?.balance
      }
    }, [isUseBalance, preSettlementData])

    const [toPayAction] = useMutation<toPay, toPayVariables>(TO_PAY, {
      fetchPolicy: 'no-cache',
    })

    const onSelectPayType = useCallback(item => {
      setCurrentPayType(item)
    }, [])

    // const onBalanceChange = useCallback(
    //   checked => {
    //     // 备注：当余额支付开启，同时余额足够时，取消三方支付; 当余额支付关闭时，默认三方支付
    //     if (
    //       checked &&
    //       preSettlementData?.balance >= preSettlementData?.totalFee
    //     ) {
    //       setIsUsePay(false)
    //       setCurrentPayType(null)
    //     } else if (!checked) {
    //       setIsUsePay(true)
    //       !currentPayType &&
    //         setCurrentPayType(preSettlementData?.payTypeList?.[0])
    //     }

    //     setIsUseBalance(checked)

    //     setSettlementVars(vars => {
    //       return {
    //         ...vars,
    //         useBalance: checked,
    //       }
    //     })
    //   },
    //   [isCanPay, preSettlementData, currentPayType]
    // )

    const toPayFn = (data: Partial<CopyrightSettlementInput>) => {
      setLoading(true)
      toPayAction({
        variables: {
          settlement: {
            ...data,
            balancePayFee: realUseBalance,
            channelPayFee: preSettlementData?.totalFee - realUseBalance,
            artworkId: currentOrderInfo?.id,
            buyType: currentOrderInfo.buyType,
            num: 1,
            useBalance: isUseBalance,
            payTypeInfo: {
              payChannel: currentPayType?.payChannel,
              payType: currentPayType?.type,
              payProvider: currentPayType?.payProvider,
            },
            usePrice: YuanToFen(usePrice),
            changePrice: YuanToFen(adaptPrice),
          },
        },
      })
        .then(data => {
          setPayInfo(
            data?.data?.orderModule
              ?.copyrightPay as toPay_orderModule_copyrightPay
          )
          // 等同于是否使用三方支付
          if (data?.data?.orderModule?.copyrightPay?.needPay) {
            setScanPayVisiable(true)
          } else {
            if (isMysteryBox) {
              store.modal?.setMysteryBoxVisible(true)
            } else {
              setPaySuccessVisible(true)
            }
          }
        })
        .catch(err => {
          const code = graphQLErrorCode(err)
          if (code === 20070003) {
            modal.confirm({
              title: '提示',
              content: <div>您有一笔当前作品的订单正在进行中</div>,
              maskStyle: {
                backgroundColor: 'rgba(0,0,0,0.8)',
              },
              width: 270,
              getContainer: false as const,
              style: { top: '300px' },
              className: 'hookModal',
              okText: '前往支付',
              onOk: close => {
                Router.push('/my/trade-history/wait-pay')
                close()
              },
              onCancel: close => {
                close()
              },
            })
            return
          }
          message.destroy()
          message.error(graphQLErrorMessage(err) || '购买失败，请重试')
        })
        .finally(() => {
          setLoading(false)
        })
    }

    const confirmNext = useCallback(
      params => {
        if (isUseBalance) {
          if (validateTradePwd()) {
            setTradePwdVisible(true)
          }

          return
        }

        toPayFn(params)
      },
      [isUseBalance, toPayFn, validateTradePwd]
    )

    const onConfirm = useCallback(async () => {
      if (!isAgree) {
        message.destroy()
        message.error('请先勾选同意相关协议')
        return
      }

      if (FenToYuan(preSettlementData?.totalFee - realUseBalance) > MAX_PAY) {
        message.destroy()
        message.error(`三方支付限额${MAX_PAY}，请使用余额进行支付`)
        return
      }

      const params: Partial<CopyrightSettlementInput> = {}

      if (!isAi && currentOrderInfo.type === SkuType.OWNER) {
        const formData = await form.validateFields()
        params.price = YuanToFen(formData.price)

        if (preSettlementData?.preIncome < 0) {
          confirm({
            title: '提示',
            content:
              '请再次确认出售价格，当前设置的出售价格卖出后你将会有收益的亏损',
            icon: '',
            maskStyle: {
              backgroundColor: 'rgba(0,0,0,0.8)',
            },
            width: 300,
            cancelText: '重新设置',
            onOk: () => {
              confirmNext(params)
            },
            okText: '确认支付',
          })

          return
        }
      }
      confirmNext(params)
    }, [
      isAgree,
      preSettlementData,
      currentOrderInfo,
      confirmNext,
      realUseBalance,
    ])

    // 输入交易密码后的回调
    // const onTradePwdCb = useCallback(
    //   tradePwdData => {
    //     const params: Partial<CopyrightSettlementInput> = {
    //       password: CryptoJS.MD5(tradePwdData?.password || '').toString(),
    //     }

    //     if (currentOrderInfo.type === SkuType.OWNER) {
    //       const formData = form.getFieldsValue()
    //       params.price = YuanToFen(formData.price)
    //     }

    //     toPayFn(params)
    //   },
    //   [toPayFn, currentOrderInfo]
    // )

    const [usePrice, setUsePrice] = useState<number | undefined>(undefined)
    const [adaptPrice, setAdaptPrice] = useState<number | undefined>(undefined)

    return mounted ? (
      <MyModal
        visible={visible}
        title="订单详情"
        onCancel={() => setVisible(false)}
        maskStyle={{
          backgroundColor: 'rgba(0,0,0,0.8)',
        }}
        width={448}
        footer={null}
      >
        <ProductInfo data={currentOrderInfo} showType={true} />

        {/* 所有权 */}
        {currentOrderInfo.type === SkuType.OWNER && !isAi && (
          <>
            <MyForm
              layout="vertical"
              initialValues={{
                useprice: usePrice,
                adaptprice: adaptPrice,
              }}
            >
              <MyForm.Item
                label={
                  <>
                    标准类授权（使用权）价格
                    <Tooltip
                      placement="topLeft"
                      title="不同使用权价格之间的比例关系，标准类授权：拓展类授权：商品类授权）=1:1.5:3，其他使用权价格将根据标准类授权价格自动计算出出售价格"
                    >
                      <QuestionCircleOutlined style={{ marginLeft: 3 }} />
                    </Tooltip>
                  </>
                }
                name="useprice"
                rules={[
                  {
                    type: 'number',
                    validator(_rule, value) {
                      if (!value) {
                        return Promise.reject('请输入使用权价格')
                      } else if (value < 1) {
                        return Promise.reject(`使用权价格需大于¥${1}`)
                      } else if (value > 1000) {
                        return Promise.reject(`使用权价格需小于¥${1000}`)
                      } else if (!isAmount.test(value)) {
                        return Promise.reject('价格最多支持两位小数')
                      }
                      return Promise.resolve()
                    },
                  },
                ]}
              >
                <InputNumber
                  controls={false}
                  addonAfter="CNY"
                  value={usePrice}
                  onChange={v => {
                    setUsePrice(v || 0)
                  }}
                  placeholder="请输入使用权价格"
                />
              </MyForm.Item>

              {usePrice && (
                <InfoCard style={{ marginBottom: 24 }}>
                  <InfoCardItem label="作品使用权价格"></InfoCardItem>
                  <InfoCardItem label="标准类授权">
                    ¥ {usePrice.toFixed(2)}
                  </InfoCardItem>
                  <InfoCardItem label="扩展类授权">
                    ¥ {(usePrice * 1.5).toFixed(2)}
                  </InfoCardItem>
                  <InfoCardItem label="商品类授权">
                    ¥ {(usePrice * 3).toFixed(2)}
                  </InfoCardItem>
                </InfoCard>
              )}

              <MyForm.Item
                label={<>改编权价格</>}
                name="adaptprice"
                rules={[
                  {
                    type: 'number',
                    validator(_rule, value) {
                      if (!value) {
                        return Promise.reject('请输入改编权价格')
                      } else if (value < 1) {
                        return Promise.reject(`改编权价格需大于¥1`)
                      } else if (value > 1000) {
                        return Promise.reject(`改编权价格需小于¥1000`)
                      } else if (!isAmount.test(value)) {
                        return Promise.reject('价格最多支持两位小数')
                      }
                      return Promise.resolve()
                    },
                  },
                ]}
              >
                <InputNumber
                  controls={false}
                  addonAfter="CNY"
                  value={adaptPrice}
                  onChange={v => {
                    setAdaptPrice(v || 0)
                  }}
                  placeholder="请输入改编权价格"
                />
              </MyForm.Item>
            </MyForm>
          </>
        )}

        {/* 使用权+ */}
        {currentOrderInfo.type === SkuType.USE && (
          <InfoCard>
            <InfoCardItem label="购买类型">
              {SkuTypeName[currentOrderInfo.type]}-{currentOrderInfo.name}
            </InfoCardItem>
            <InfoCardItem label="支付金额">
              ¥{FenToYuan(preSettlementData?.totalFee)}
            </InfoCardItem>
          </InfoCard>
        )}

        {/*改编权*/}
        {currentOrderInfo.type === SkuType.ADAPT && (
          <InfoCard>
            <InfoCardItem label="购买类型">
              {SkuTypeName[currentOrderInfo.type]}
            </InfoCardItem>
            <InfoCardItem label="支付金额">
              ¥{FenToYuan(preSettlementData?.totalFee)}
            </InfoCardItem>
          </InfoCard>
        )}

        {/* <InfoCard>
          <InfoCardItem
            label={
              <>
                可用积分{' '}
                <Tooltip
                  placement="topLeft"
                  title="购买版权作品可获得购买金额*5%的积分，可用积分=当前账户可用积分+此次购买成功后可获得的积分"
                >
                  <QuestionCircleOutlined />
                </Tooltip>
              </>
            }
          >
            {preSettlementData?.balancePoint}
          </InfoCardItem>
          <InfoCardItem label={<>可用余额</>}>
            ¥{FenToYuan(preSettlementData?.balance)}
          </InfoCardItem>
          <InfoCardItem label={<>余额支付</>}>
            <Switch
              checked={isUseBalance}
              onChange={onBalanceChange}
              disabled={!isCanBalance}
            />
          </InfoCardItem>
        </InfoCard> */}

        <InfoCard>
          {preSettlementData?.payTypeList
            ?.filter(item => item?.available)
            .map(item => (
              <InfoCardItem
                key={item?.name}
                label={
                  <>
                    <img
                      width={24}
                      style={{ marginRight: 8, marginTop: -3 }}
                      src={item?.icon || ''}
                      alt=""
                    />
                    {item?.name}
                  </>
                }
              >
                <Radio
                  style={{ marginRight: 0 }}
                  checked={currentPayType?.name === item?.name}
                  disabled={!isCanPay}
                  onChange={() => onSelectPayType(item)}
                />
              </InfoCardItem>
            ))}
        </InfoCard>

        <div className="bg-neutral-700 text-neutral-100 px-4 py-2 mb-3 text-xs rounded-[48px]">
          <span className="text-neutral-400 mr-1">
            <InfoCircleOutlined />
          </span>
          版权作品一旦出售无法退款
        </div>

        <div>
          <MyCheckbox
            checked={isAgree}
            onChange={e => setIsAgree(e.target.checked)}
          >
            我已阅读并同意《
            <a
              href={
                isAi
                  ? AiSkuTypeAgreement[currentOrderInfo.type]
                  : SkuTypeAgreement(hasAdapt)[currentOrderInfo.type]
              }
              target="_blank"
              rel="noreferrer"
              className="primary-color"
            >
              购买协议
            </a>
            》
          </MyCheckbox>
        </div>

        <StyledOrderAction>
          <StyledOrderActionPrice>
            {isUseBalance && (
              <StyledOrderActionPriceItem>
                余额支付 <span>¥{FenToYuan(realUseBalance)}</span>
              </StyledOrderActionPriceItem>
            )}

            {isUsePay && (
              <StyledOrderActionPriceItem>
                {currentPayType?.name}{' '}
                <span>
                  ¥{FenToYuan(preSettlementData?.totalFee - realUseBalance)}
                </span>
              </StyledOrderActionPriceItem>
            )}
          </StyledOrderActionPrice>
          <MyBtn type="primary" onClick={onConfirm} loading={loading}>
            确认支付
          </MyBtn>
        </StyledOrderAction>

        {/* {tradePwdVisible && (
          <TradePwdModal
            visible={tradePwdVisible}
            setVisible={setTradePwdVisible}
            onSuccess={onTradePwdCb}
          />
        )} */}
        {scanPayVisiable && (
          <ScanPayModal
            visible={scanPayVisiable}
            setVisible={setScanPayVisiable}
            payInfo={payInfo}
            icon={currentPayType?.icon || ''}
            needLock={true}
            amount={preSettlementData?.totalFee - realUseBalance}
          />
        )}
        {paySuccessVisiable && (
          <OrderSuccessModal
            visible={paySuccessVisiable}
            setVisible={setPaySuccessVisible}
            payInfo={payInfo}
          />
        )}
        {store.modal?.mysteryBox && <MysteryBoxModal payInfo={payInfo} />}
        {modalSlot}
      </MyModal>
    ) : (
      <></>
    )
  }
)
